var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"website-pro-absolute-fill-parent website-pro-flex column center website-pro-background-image-style",class:_vm.customClasses,style:(_vm.style),attrs:{"draggable":"false","href":_vm.href,"target":_vm.target}})}
var staticRenderFns = []

export { render, staticRenderFns }